const LANGUAGES = [
 { label: "English", code: "en", flag: "🇬🇧" },
 { label: "Italian", code: "it", flag: "🇮🇹" },
];

export { LANGUAGES }